import type { State } from '../../types';
import { getOrganization } from '../organization/getOrganization';
import type { IssueEscalationSettings } from '../../../content/issues/issue-escalation';

/** Standard antall dager til frist når organisasjonen ikke har satt en egen verdi. */
export const DEFAULT_ESCALATION_DAYS = 14;

/**
 * Organisasjonens eskaleringsinnstillinger for avvik (krav 1.2.1), lest fra
 * organisasjonsinnstillingene i staten (dabih-api#4687).
 */
export function issueEscalationSettings(state: State): IssueEscalationSettings {
  const organization = getOrganization(state);
  return {
    enabled: organization?.issueEscalationEnabled ?? false,
    days:
      organization?.issueEscalationDays && organization.issueEscalationDays > 0
        ? organization.issueEscalationDays
        : DEFAULT_ESCALATION_DAYS,
    recipients: organization?.issueEscalationRecipients ?? [],
    notifyAssignee: organization?.notifyAssignee ?? true,
  };
}
